import { newToolFilterOAuthMcp } from "../oauth.ts";

export const simplescraperMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://simplescraper.io/favicon.ico",
  url: "https://mcp.simplescraper.io/mcp",
  label: "Simplescraper",
});
